import { validatePassword } from '../../utils/validation'
import { Container, RequirementsList, Requirement, Icon } from './styles'

export function PasswordStrength({ password }) {
  const validation = validatePassword(password)

  const requirements = [
    { key: 'minLength', label: 'Mínimo 8 caracteres', met: validation.minLength },
    { key: 'hasUppercase', label: 'Pelo menos 1 letra maiúscula', met: validation.hasUppercase },
    { key: 'hasNumber', label: 'Pelo menos 1 número', met: validation.hasNumber },
  ]

  return (
    <Container>
      <RequirementsList>
        {requirements.map((req) => (
          <Requirement key={req.key} $met={req.met}>
            <Icon>{req.met ? '✓' : '✗'}</Icon>
            {req.label}
          </Requirement>
        ))}
      </RequirementsList>
    </Container>
  )
}
